import { Group, ScrollArea, Stack } from '@mantine/core';
import i18n from '../../../../../base-dictionary';
import { useRelatedTasksTabStore } from '../../../../../store/strategy-store/strategy-store';
import {
  setPerformanceActivePanel,
  setRelatedTasksSelectedTask,
} from '../../../../../store/strategy-store/strategy-store.actions';
import { secondaryBase, skyDark } from '../../../../../styles/design-tokens';
import { Divider } from '../../../../../ui-library/divider/divider';
import { Icon } from '../../../../../ui-library/icon/icon';
import { Tooltip } from '../../../../../ui-library/tooltip/tooltip';
import { Text } from '../../../../../ui-library/typography/typography';
import { SideSectionInfo } from './side-section-info';
import { SideSectionInitiatives } from './side-section-initiatives';
import { SideSectionTaskLog } from './side-section-task-log';

export const SideSection = () => {
  const task = useRelatedTasksTabStore((state) => state.selectedTask);

  if (!task) {
    return null;
  }

  const handleKeyClick = () => {
    if (task.url) {
      window.open(task.url, '_blank', 'noopener, noreferrer');
    }
  };

  return (
    <Stack h="100%">
      <Group justify={'space-between'}>
        <Group gap={4} style={{ cursor: task.url ? 'pointer' : 'default' }} onClick={handleKeyClick}>
          <Text weight="bold" size="medium" color={secondaryBase}>
            {task.title}
          </Text>
          <Tooltip variant="white" label={i18n.t('common.visit_source_page')} position="right">
            <Icon
              name="arrow_outward"
              size={16}
              color={secondaryBase}
              pointer={Boolean(task.url)}
              aria-label={i18n.t('common.visit_source_page')}
            />
          </Tooltip>
        </Group>
        <Icon
          name="close"
          onClick={() => {
            setRelatedTasksSelectedTask(null);
            setPerformanceActivePanel(null);
          }}
          size={20}
          color={skyDark}
          aria-label="Close panel"
        />
      </Group>
      <Divider />
      <ScrollArea h="100%" scrollbarSize={0}>
        <Stack>
          <Text weight="medium" size="medium">
            {task.name}
          </Text>
          <Divider />
          <SideSectionInitiatives />
          <Divider />
          <SideSectionInfo task={task} />
          <Divider />
          <SideSectionTaskLog />
        </Stack>
      </ScrollArea>
    </Stack>
  );
};
